import { render, staticRenderFns } from "./uploadBidFile.vue?vue&type=template&id=2b9c6d5b&scoped=true"
import script from "./uploadBidFile.vue?vue&type=script&lang=js"
export * from "./uploadBidFile.vue?vue&type=script&lang=js"
import style0 from "./uploadBidFile.vue?vue&type=style&index=0&id=2b9c6d5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9c6d5b",
  null
  
)

export default component.exports